import TYPES from '@/types';
import i18n from '@/vue-app/plugins/i18n';

// Application
import CustomerOverviewService from '@/modules/home-dashboard/customer-overview/application/services/customer-overview-service';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import { DateFormatter } from '@/modules/shared/domain/date-formatters';
import CustomerOverviewState from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state';

export class MembershipInformationViewModel {
  @Inject(TYPES.CUSTOMER_OVERVIEW_SERVICE)
  private readonly customer_overview_service!: CustomerOverviewService;

  @Inject(TYPES.DATE_FORMATTER)
  readonly date_formatter!: DateFormatter;

  readonly i18n_namespace = 'components.my-investment-dashboard.membership';

  readonly membership_name = 'SOWOS +';

  is_loading = false;

  customer_overview: CustomerOverviewState = this.customer_overview_service.get_customer_overview();

  constructor() {
    this.addReloadInvitationsSentEventListener();
  }

  removeEventListeners = () => {
    window.removeEventListener('reload.invitations.sent', this.reloadReferralsInformation);
  }

  addReloadInvitationsSentEventListener = () => {
    window.addEventListener('reload.invitations.sent', this.reloadReferralsInformation);
  }

  get full_name() {
    const { name, last_name, second_last_name } = this.customer_overview
      .item.personal_information_overview;
    return `${name} ${last_name} ${second_last_name}`;
  }

  get on_boarding_completed_date() {
    return this.date_formatter.formatDate(this.customer_overview.item.onboarding_completed_at, 'DD MMM YYYY');
  }

  get referrals() {
    return this.customer_overview.item.referrers_overview.completed;
  }

  get invitations_sent() {
    return this.customer_overview.item.referrers_overview.sent;
  }

  reloadReferralsInformation = () => {
    this.customer_overview.item.referrers_overview.sent += 1;
  }

  translate = (value: string, count?: number, values?: Record<string, string | number>) => (values ? i18n.tc(`${this.i18n_namespace}.${value}`, count, values) as string : i18n.t(`${this.i18n_namespace}.${value}`) as string);
}
